/* ng-infinite-scroll - v1.0.0 - 2013-02-23 */
(function (angular) {
  "use strict";

  angular.module("Toyota.Directives").directive("infiniteScroll", [
    "$rootScope",
    "$window",
    "$timeout",
    function ($rootScope, $window, $timeout) {
      return {
        link: function (scope, elem, attrs) {
          var checkWhenEnabled, handler, scrollDistance, scrollEnabled;
          scrollDistance = 0;

          if (typeof attrs.infiniteScrollDistance !== "undefined") {
            scope.$watch(attrs.infiniteScrollDistance, function (value) {
              return (scrollDistance = parseInt(value));
            });
          }

          scrollEnabled = true;
          checkWhenEnabled = false;

          if (typeof attrs.infiniteScrollDisabled !== "undefined") {
            scope.$watch(attrs.infiniteScrollDisabled, function (value) {
              scrollEnabled = !value;
              if (scrollEnabled && checkWhenEnabled) {
                checkWhenEnabled = false;
                return handler();
              }

              return undefined;
            });
          }

          handler = function () {
            var elementBottom, remaining, shouldScroll, windowBottom;
            windowBottom = angular.element($window).height() + angular.element($window).scrollTop();
            elementBottom = elem.offset().top + elem.height();
            remaining = elementBottom - windowBottom;
            shouldScroll = remaining <= angular.element($window).height() * scrollDistance;

            if (shouldScroll && scrollEnabled) {
              if ($rootScope.$$phase) {
                return scope.$eval(attrs.infiniteScroll);
              }

              return scope.$apply(attrs.infiniteScroll);
            } else if (shouldScroll) {
              return (checkWhenEnabled = true);
            }

            return undefined;
          };

          angular.element($window).on("scroll", handler);

          scope.$on("$destroy", function () {
            return angular.element($window).off("scroll", handler);
          });

          return $timeout(function () {
            if (attrs.infiniteScrollImmediateCheck) {
              if (scope.$eval(attrs.infiniteScrollImmediateCheck)) {
                return handler();
              }
            } else {
              return handler();
            }

            return undefined;
          }, 0);
        },
      };
    },
  ]);
})(window.angular);
